<template>
    <div class="card-content">
        <el-form :model="form" label-width="100px">
            <el-form-item :label="$t('cardNo')" v-if="methodInfo.hasCard">
                <el-input v-model="form.card"></el-input>
            </el-form-item>
            <el-form-item :label="$t('serialNo')" v-if="methodInfo.hasSerial">
                <el-input v-model="form.serial"></el-input>
            </el-form-item>


          <div class="wallet-content" v-if="methodInfo.showAmountList">
            <div class="currency" v-if="currencyList.length > 1">
              <label for="currency-select">{{ $t('selectCurrency') }}：</label>
              <el-select id="currency-select" v-model="selectedCurrency" :placeholder="$t('selectCurrency')" class="currency-select">
                <el-option
                  v-for="currency in currencyList"
                  :label="currency"
                  :value="currency">
                </el-option>
              </el-select>
            </div>

            <div class="amount-list">
              <div class="item" v-for="(amount,index) in amount1[selectedCurrency]" :class="{ 'item-active':selectedAmountIndex == index }" @click="selectedAmountIndex = index">
                <div class="amount">{{ selectedCurrency + ' ' + amount }}</div>
                <div class="eg">{{  getEgPoint(amount) }} EG Points</div>
              </div>
            </div>
          </div>

          <recharge-by-direct v-if="showIframe" :rechargeUrl="rechargeUrl" :channelKey="channelKey" :methodInfo="methodInfo" :user="user" :browserInfo="browserInfo"></recharge-by-direct>

          <recharge-by-js-load :txnId="txnId" v-if="showJsRecharge"></recharge-by-js-load>

          <recharge-by-post :v-if="showPostIframe" :rechargePostUrl="rechargePostUrl" :xmlData="xmlData"></recharge-by-post>

          <recharge-by-loc :v-if="showLoc" :rechargeLocUrl="rechargeLocUrl"></recharge-by-loc>


            <el-form-item class="submit-btn">
                <el-button type="primary" @click="handleSubmit">{{ $t('buyEgPoint') }}</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
  import rate from '../../config/rate'
  import RechargeByDirect from './RechargeByDirect.vue'
  import RechargeByJsLoad from './RechargeByJsLoad.vue'
  import RechargeByLoc from './RechargeByLoc.vue'
  import RechargeByPost from './RechargeByPost.vue'
    export default {
        data() {
            return {
                form: {
                    card: '',
                    serial: ''
                },
                showIframe: false,
                showPostIframe: false,
                showAmountList: true,
                rechargeUrl: '',
                txnId: '',
                showJsRecharge: false,
                xmlData:'',
                showLoc: false,
                showResult: false,
                rechargeStatus: '',
                rechargeCode: '',
                currency: '',
                amount: '',
                showLoading: false,
                selectedAmountIndex: 0,
                selectedCurrency: ''
            };
        },
        components: {
          RechargeByDirect,
          RechargeByJsLoad,
          RechargeByLoc,
          RechargeByPost
        },
        props: ['channelKey', 'methodInfo', 'user', 'browserInfo'],
        computed: {
          amount1() {
            return this.methodInfo.amount;
          },
          currencyList() {
            return Object.keys(this.methodInfo.amount);
          }
        },
        created() {
          this.selectedCurrency = this.currencyList[0];
        },
        methods: {
            getEgPoint(val) {
              return Math.floor(parseInt(val) * rate[this.selectedCurrency]);
            },
            handleSubmit() {
                if (this.methodInfo.hasCard && !this.form.card) {
                    this.$message.warning(this.$t('cardNotEmpty'));
                    return;
                }
                if (this.methodInfo.hasSerial && !this.form.serial) {
                    this.$message.warning(this.$t('serialNotEmpty'));
                    return;
                }
                this.cardRecharge();
            },
            cardRecharge() {
                this.$emit('openLoading');
                // console.log(this.methodInfo.showAmountList)
                // return false
                if(this.methodInfo.showAmountList == false) {
                  let apiParams = {
                    uid: this.user.uid,
                    token: this.user.accessToken,
                    browser_version: this.browserInfo.version,
                    browser_name: this.browserInfo.name,
                    card: this.form.card,
                    serial: this.form.serial,
                    key: this.methodInfo.key,
                  };
                  if(this.channelKey == 'bluepay') {
                    apiParams.country = this.methodInfo.country;
                  }

                  let queryString = '';
                  Object.keys(apiParams).forEach(function(key){
                    queryString += (key + '=' + apiParams[key] + '&');
                  });

                  this.$http.get('recharge/' + this.channelKey + '/pay?' + queryString).then(
                    function (response) {
                      this.$emit('closeLoading');
                      let apiResult = response.data;
                      switch(apiResult.code) {
                        case -1:
                          this.$emit('close');
                          this.$alert(this.$t('createOrderFailTryAgain'), this.$t('createOrderFail'), {
                            confirmButtonText: this.$t('confirm'),
                          });
                          break;
                        case -2:
                          this.$emit('close');
                          this.$alert(this.$t('rechargeFailErrCode') + apiResult.message, this.$t('rechargeFail'), {
                            confirmButtonText: this.$t('confirm'),
                          });
                          break;
                        case 1:
                          this.$emit('close');
                          this.$alert(this.$t('rechargeSuccessAmount') + apiResult.message.currency + ' ' + apiResult.message.amount, this.$t('rechargeSuccess'), {
                            confirmButtonText: this.$t('confirm'),
                          });
                          break;
                        case 0:
                          this.$emit('close');
                          this.$alert(this.$t('rechargeFinishCheckLater'), this.$t('rechargeFinish'), {
                            confirmButtonText: this.$t('confirm'),
                          });
                          break;
                        case 2019:
                          this.$emit('close');
                          this.$alert(that.$t('isBlocked'), that.$t('buyGoodsFail'));
                          break;
                        default:
                          this.$emit('close');
                          this.$alert(this.$t('systemErrorTryLater'), this.$t('systemError'), {
                            confirmButtonText: this.$t('confirm'),
                          });
                      }
                    },
                    function (response) {
                      this.$emit('closeLoading');
                      this.$emit('close');
                      this.$alert(this.$t('systemErrorTryLater'), this.$t('systemError'), {
                        confirmButtonText: this.$t('confirm'),
                      });
                    }
                  );
                } else{
                  let apiParams = {
                    uid: this.user.uid,
                    token: this.user.accessToken,
                    browser_version: this.browserInfo.version,
                    browser_name: this.browserInfo.name,
                    currency: this.selectedCurrency,
                    amount: this.amount1[this.selectedCurrency][this.selectedAmountIndex],
                    country: 'sms'
                  }
                  let queryString = '';
                  Object.keys(apiParams).forEach(function(key){
                    queryString += (key + '=' + apiParams[key] + '&');
                  });
                  this.$http.get('recharge/' + this.channelKey + '/pay?' + queryString).then(
                    function (response) {
                      this.$emit('closeLoading');
                      let apiResult = response.data;
                      switch(apiResult.code) {
                        case -1:
                          this.$emit('close');
                          this.$alert(this.$t('createOrderFailTryAgain'), this.$t('createOrderFail'), {
                            confirmButtonText: this.$t('confirm'),
                          });
                          break;
                        case -2:
                          this.$emit('close');
                          this.$alert(this.$t('rechargeFailErrCode') + apiResult.message, this.$t('rechargeFail'), {
                            confirmButtonText: this.$t('confirm'),
                          });
                          break;
                        case 1:
                          this.$emit('close');
                          this.$alert(this.$t('rechargeSuccessAmount') + apiResult.message.currency + ' ' + apiResult.message.amount, this.$t('rechargeSuccess'), {
                            confirmButtonText: this.$t('confirm'),
                          });
                          break;
                        case 2:
                          let rechargeUrl = apiResult.message;
                          this.rechargeUrl = rechargeUrl;
                          this.showAmountList = false;
                          this.showIframe = true;
                          break;
                        case 3:
                          this.txnId = apiResult.message;
                          this.showAmountList = false;
                          this.showJsRecharge = true;
                          break;
                        case 4:
                          let rechargePostUrl = apiResult.message;
                          this.rechargePostUrl = rechargePostUrl;
                          this.xmlData = apiResult.data;
                          this.showPostIframe = true;
                          this.showAmountList = false;
                          this.showIframe = false;
                          break;
                        case 5:
                          let rechargeLocUrl = apiResult.message;
                          this.rechargeLocUrl = rechargeLocUrl;
                          this.showLoc = true;
                          this.showPostIframe = false;
                          this.showAmountList = false;
                          this.showIframe = false;
                          break;
                        case 2019:
                          this.$emit('close');
                          this.$alert(that.$t('isBlocked'), that.$t('buyGoodsFail'));
                          break;
                        default:
                          this.$emit('close');
                          this.$alert(this.$t('systemErrorTryLater'), this.$t('systemError'), {
                            confirmButtonText: this.$t('confirm'),
                          });
                      }
                    },
                    function (response) {
                      this.$emit('closeLoading');
                      this.$emit('close');
                      this.$alert(this.$t('systemErrorTryLater'), this.$t('systemError'), {
                        confirmButtonText: this.$t('confirm'),
                      });
                    }
                  );
                }
            }
        }
    }
</script>


<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../../assets/scss/lib";

    .card-content {
        width: 80%;
        margin: 30px auto;
        height: auto;
    }

    .submit-btn {
        @include flex-row-center;
        margin-top: 30px;
    }

    .el-button {
        width: 250px;
        height: 45px;
        font-size: 18px;
    }

    .wallet-content {
      max-height: 400px;
    }

    .currency {
      @include flex-row-center;
      margin: 20px auto 0;
      width: 70%;
      label {
        color: #5e6d82;
        width: 150px;
        text-align: right;
      }
      .currency-select {
        width: 80%;
      }
    }

    .amount-list {
      margin: 20px auto 0;
      @include flex;
      @include flex-wrap;
      overflow-y: auto;
      max-height: 260px;
      width: 88.5%;
      .item {
        width: 150px;
        height: 70px;
        border: 1px dotted #9a9a9a;
        margin: 10px;
        @include flex-column-center;
        @include no-select;
        &:hover {
          cursor: pointer;
        }
        .amount {
          font-weight: bold;
        }
        .eg {
          margin-top: 10px;
          color: #616161;
          font-size: 14px;
        }
      }
      .item-active {
        background: #c0eaf6;
      }
    }
</style>



// WEBPACK FOOTER //
// RechargeByCard.vue?9a5a388e